import { Box } from '@mui/material';
import * as React from 'react';

import { TListBoxWrapperProps } from '@/shared/components/ui/form/components/searchable-select/components/list-box/components/list-box-wrapper/list-box-wrapper.types';

export const ListBoxWrapperContext = React.createContext({});

export const ListBoxWrapper: React.FC<TListBoxWrapperProps> = ({
  ref,
  ...props
}) => {
  const outerProps = React.useContext(ListBoxWrapperContext);
  return <Box ref={ref} {...props} {...outerProps} />;
};
